import { css, keyframes } from '@emotion/react';
import { Easing } from 'client/Theme';

export const waveAnimation = keyframes`
  0%, 50% { transform: translateY(0%); }
  75% { transform: translateY(-10%); }
  100% { transform: translateY(0%); }
`;

const ellipsisStyle = css`
  position: relative;

  > span {
    display: inline-block;
    animation: ${waveAnimation} 1500ms infinite ${Easing.springy};
  }

  > span:nth-child(2) {
    animation-delay: 0ms;
  }

  > span:nth-child(2) {
    animation-delay: 150ms;
  }

  > span:nth-child(3) {
    animation-delay: 300ms;
  }
`;

export const EllipsisLoader = () => (
  <span css={ellipsisStyle}>
    <span>.</span>
    <span>.</span>
    <span>.</span>
  </span>
);
